var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.787 17.234-3.311 7.67-.711 1.762c1.285.272 2.765.418 4.09.148a9.043 9.043 0 0 0 3.123-1.505l-3.192-8.075z",
    clipRule: "evenodd",
    fill: "#73B158",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.294 21.055",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.798 8.886.018 6.685v.002l3.366 1.029 3.554 1.084-6.938-8.8z",
    clipRule: "evenodd",
    fill: "#226188",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.816 15.572 3.366 1.03-3.366-1.03zm-0.02-6.685h3e-3v-1e-3h-3e-3z",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.138.649A8.79 8.79 0 0 0 7.603 3.94L7.558 4c-.027.035-.051.071-.078.106l7.318 4.778L13.138.65z",
    clipRule: "evenodd",
    fill: "#29A5BA",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m.611 19.453 7.194-1.766L1.71 14.35C.576 16.378.476 18.217.61 19.453z",
    clipRule: "evenodd",
    fill: "#73B158",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m23.263 11.966.003.003-.003-.003z",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m.614 19.494.008.07.016.085c.458 2.653 1.891 4.275 2.88 5.109l4.287-7.071-7.194 1.766.003.041z",
    clipRule: "evenodd",
    fill: "#68A855",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.816 24.997a.628.628 0 0 1 .05.039l.041.03c1.45 1.06 2.843 1.742 5.298 1.869a8.945 8.945 0 0 0 1.177-.02c-.657-2.373-2.47-8.892-2.577-9.226v-.003l-4.287 7.072c.105.088.205.168.298.239z",
    clipRule: "evenodd",
    fill: "#5B9E54",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.382 26.914h.003l.104-.008.068-.007.09-.01c1.52-.173 2.758-.694 3.582-1.042.198-.083.372-.156.516-.21-1.673-.997-3.01-2.234-4.047-3.43v-.002a18.991 18.991 0 0 1-1.564-2.08 19.486 19.486 0 0 1-.547-.892 9.768 9.768 0 0 1-.397-.73c-.385-.813-.38-.803-.385-.817",
    clipRule: "evenodd",
    fill: "#5A9252",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.711 2.143a8.8 8.8 0 0 0-2.646-1.27 6.548 6.548 0 0 0-2.147-.34h-.042a8.826 8.826 0 0 0-1.656.101l-.082.014 1.658 8.237 5.032-6.657c-.039-.028-.076-.058-.117-.086z",
    clipRule: "evenodd",
    fill: "#1E98B0",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 6.911a8.58 8.58 0 0 0-2.269-3.85 8.906 8.906 0 0 0-.983-.833l-5.032 6.657h.003l8.29-1.943-.008-.031z",
    clipRule: "evenodd",
    fill: "#218DA5",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.423 10.071c0 .036-.003.073-.003.11 0-.039.003-.075.003-.11zM14.816 15.571a.773.773 0 0 0-.033.012l.033-.01v-.002z",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.816 15.572a.338.338 0 0 0-.033.01c-.005.001-.007.002 0 0-.353.103-.43.128-6.978 2.105l13.931-.001-3.553-1.084-3.367-1.03z",
    clipRule: "evenodd",
    fill: "#95C65B",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m14.783 15.583.033-.01-.033.01z",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.843 10.5a.732.732 0 0 1-.02.01c-1.739.867-3.143 2.132-3.96 3.575l-.01.02c-.05.082-.097.163-.144.246l6.096 3.336L5.843 10.5z",
    clipRule: "evenodd",
    fill: "#83BD5C",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.799 8.885 7.48 4.107a8.51 8.51 0 0 0-1.663 4.705c0 .008-.045.648.023 1.677 0 .004 0 .006.002.01a9.7 9.7 0 0 1 .537-.247v-.005.005a17.067 17.067 0 0 1 4.09-1.157c.493-.075.99-.13 1.486-.17.971-.075 1.958-.057 2.843-.039z",
    clipRule: "evenodd",
    fill: "#25B3C4",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.816 15.571 14.8 8.887l-6.994 8.8c6.547-1.977 6.625-2.003 6.978-2.104-.02.005.029-.01.033-.012z",
    clipRule: "evenodd",
    fill: "#9EC95B",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.816 15.571 14.8 8.886v.001l.017 6.684z",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m7.805 17.686 6.991-8.799c-.882-.02-1.869-.037-2.84.039a21.183 21.183 0 0 0-1.91.239A17.08 17.08 0 0 0 6.38 10.25v-.004.004c-.177.075-.357.159-.537.247H5.84l.003.001 1.962 7.187z",
    clipRule: "evenodd",
    fill: "#91C45A",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.134 20.126zM8.587 19.233zM8.787 19.574zM8.19 18.503zM8.19 18.503c-.256-.496-.378-.801-.385-.813.007.012.13.317.385.813z",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.692 17.642c-.853.336-1.714.68-2.57 1.026-1.29.52-2.583 1.05-3.87 1.582a804.081 804.081 0 0 0-3.826 1.592c-.003 0-.005 0-.007.002l-.765.319c1.036 1.197 2.374 2.432 4.047 3.43.68.391 1.564.715 2.847 1.043l.08.02.006.002.12.024c.018.003-.017-.003 0 0l.727-1.664 3.21-7.376z",
    clipRule: "evenodd",
    fill: "#83BD5C",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m15.296 20.294",
    clipRule: "evenodd",
    fill: "#7CBC56",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.805 17.686v.004c.007.013.13.317.385.813.106.21.24.458.397.73a20.602 20.602 0 0 0 1.096 1.69 18.53 18.53 0 0 0 1.015 1.282c.254-.104.51-.212.765-.318.002 0 .005 0 .007-.002a1193.157 1193.157 0 0 1 3.826-1.592c1.286-.53 2.58-1.06 3.87-1.581.857-.346 1.717-.69 2.57-1.026H7.806z",
    clipRule: "evenodd",
    fill: "#91C45A",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.354 8.424a8.57 8.57 0 0 0-.246-1.415l-.019-.067-8.29 1.943v.001l8.465 3.08v.002c.02-.172.036-.33.057-.491.044-.35.085-.9.1-1.297l.002-.109a12.516 12.516 0 0 0-.069-1.647z",
    clipRule: "evenodd",
    fill: "#20839F",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.592 17.808a9.383 9.383 0 0 0-.484-2.343l-6.372 2.221 6.594 2.762c.165-.661.345-1.597.262-2.64z",
    clipRule: "evenodd",
    fill: "#5B9E54",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m28.33 20.448-6.594-2.762 3.247 7.62c2.311-1.618 3.042-3.801 3.05-3.825.09-.285.162-.528.224-.76h.002l.022-.089.015-.053.003-.011c.008-.04.02-.08.03-.12z",
    clipRule: "evenodd",
    fill: "#68A855",
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m14.798 8.886 6.938 8.8c.009-.019.848-1.464 1.527-5.72l-8.465-3.08z",
    clipRule: "evenodd",
    fill: "#267491",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.063 15.337c-.802-2.135-2.296-3.542-3.391-4.28a8.306 8.306 0 0 0-1.258-.703c.002-.058.005-.115.006-.173a17.08 17.08 0 0 1-.1 1.296c-.02.16-.04.318-.056.49-.68 4.255-1.52 5.701-1.528 5.719l6.372-2.22c-.016-.043-.03-.087-.045-.13z",
    clipRule: "evenodd",
    fill: "#5A9252",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2908d5538e48a925c82e088ad84873c1.svg";
export { ForwardRef as ReactComponent };